module.exports = __webpack_public_path__ + "img/RVN.b0ee8060.svg";